<template>

  <div v-if="interactive_store.display_action_modal">

    <!-- overlay -->
    <div class="overlay" @click.self="interactive_store.close_action_modal"></div>

    <!-- modal -->
    <div class="wrapper">

      <div class="card">

        <div class="icon-box" :class="interactive_store.action_modal_type">

          <font-awesome-icon
            :icon="iconMap[interactive_store.action_modal_type]"
          />

        </div>

        <h3 v-if="interactive_store.action_modal_title" class="title">
          {{ interactive_store.action_modal_title }}
        </h3>

        <p class="message">
          {{ interactive_store.action_modal_message }}
        </p>

        <!-- buttons -->
        <div class="actions">

          <button
            v-if="interactive_store.action_modal_type === 'confirm'"
            class="btn cancel"
            @click="interactive_store.cancelAction()"
          >
            Cancel
          </button>

          <button
            class="btn primary"
            @click="interactive_store.confirmAction()"
          >
            {{ interactive_store.action_modal_type === 'confirm' ? 'Confirm' : 'OK' }}
          </button>

        </div>

      </div>

    </div>

  </div>

</template>


<script setup>

import { useInteractiveStore } from '@/stores/interactive'

const interactive_store = useInteractiveStore()


const iconMap = {

  info: 'fa-solid fa-circle-info',
  success: 'fa-solid fa-circle-check',
  error: 'fa-solid fa-circle-xmark',
  warning: 'fa-solid fa-triangle-exclamation',
  confirm: 'fa-solid fa-circle-question'

}


</script>


<style scoped>

.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.55);
  backdrop-filter: blur(4px);
  z-index: 50;
}


.wrapper {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 60;
}


.card {

  width: 100%;
  max-width: 420px;

  background: white;

  border-radius: 16px;

  padding: 26px;

  text-align: center;

  box-shadow:
  0 20px 50px rgba(0,0,0,.2);

  animation: pop .25s ease;

}


.icon-box {

  font-size: 30px;

  margin-bottom: 10px;

}


.icon-box.info {
  color: #2f80ed;
}


.icon-box.success {
  color: #27ae60;
}


.icon-box.error {
  color: #eb5757;
}


.icon-box.warning {
  color: #f2994a;
}


.icon-box.confirm {
  color: #9b51e0;
}


.title {

  font-size: 18px;

  font-weight: 600;

  margin-bottom: 8px;

}


.message {

  font-size: 14px;

  color: #555;

  margin-bottom: 20px;

}


.actions {

  display: flex;

  gap: 10px;

}


.btn {

  flex: 1;

  padding: 10px;

  border-radius: 10px;

  border: none;

  font-size: 14px;

  cursor: pointer;

}


.primary {

  background: #2f80ed;

  color: white;

}


.cancel {

  background: #eee;

}


@keyframes pop {

  from {
    transform: translateY(10px) scale(.98);
    opacity: 0;
  }

  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }

}

</style>